import React from 'react';
// nodejs library to set properties for components

class RoundedButton extends React.Component {
  render() {
    return (
      <button
        onClick={this.props.onClick}
        className="roundedIcon"
        data-test="reveal-answer-button"
      >
        <i className={this.props.iconClass} />
      </button>
    );
  }
}

export default RoundedButton;
